<script>
import { mapGetters, mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Homepage components'
    },

    extends: TableView,

    data() {
        const { type = 'newsbreaker' } = this.$route.query;

        return {
            pageTitle: 'Homepage components',
            activeTab: {
                value: type
            }
        };
    },

    computed: {
        ...mapGetters({
            ALL_TYPES: 'homepageComponents/ALL_TYPES'
        }),

        labels() {
            return [
                {
                    value: 'campuses',
                    width: '300px',
                    filterFieldName: 'campuses.name',
                    sortable: false,
                    filter: 'joinTable'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        tabsElements() {
            return [...this.ALL_TYPES];
        },

        options() {
            return {
                linkSuffix: `&type=${this.activeTab.value}`,
                searchInput: false
            };
        },

        additionalFetchData() {
            return {
                type: this.activeTab.value
            };
        }
    },

    watch: {
        activeTab() {
            this.pagination.currentPage = 1;
            this.pagination.sortBy = 'createdAt';

            this.fetchItems();
        }
    },

    methods: {
        ...mapActions({
            getItems: 'homepageComponents/index',
            deleteItem: 'homepageComponents/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(
                `/homepage-components/${this.activeTab.value}/${id}/edit`
            );
        },
        onAddButtonClick() {
            this.$router.push(
                `/homepage-components/${this.activeTab.value}/add`
            );
        }
    }
};
</script>
